const baseRoute = '/virtual-ad-vehicles'

export const VirtualAdVehiclesAreaRoutes = {
  route: baseRoute,
  path: '/',
}
